import React, { FC } from 'react';

import attendanceStyles from 'components/Admin/AttendanceDetails.module.scss';
import Dialog from 'components/Dialog';
import sharedStyles from 'components/shared.module.scss';
import { Button, LoaderSpinner } from 'components/UtilElements';
import * as dt from 'core/datetime';
import { DATE_FORMAT } from 'globals/constants';
import { useAllClassAttendanceData } from 'services/admin-api';

interface CourseAttendanceDetailsProps {
  isOpen: boolean;
  course: CourseAverageAttendance | null;
  onClose(): void;
}

const CourseAttendanceDetails: FC<CourseAttendanceDetailsProps> = ({ isOpen, course, onClose }) => {
  const { data: attendances = [], isLoading } = useAllClassAttendanceData(course);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title='Attendance for all sessions'
      footer={
        <Button variant='text' color='success' size='small' onClick={onClose} preventHoverStyles>
          DONE
        </Button>
      }
    >
      {course === null || isLoading ? (
        <div className={sharedStyles['loader-wrapper']}>
          <LoaderSpinner />
        </div>
      ) : (
        <div className={attendanceStyles['class-attendance-details-body']}>
          <div className={attendanceStyles.header}>
            <div className={attendanceStyles['header-row']}>
              <div>
                {course.courseCode} - {course.title}
              </div>
              <div>Avg. Attendance {course.averageAttendance}%</div>
            </div>
            <div className={attendanceStyles['header-row']}>
              <div>{course.courseAdmin.name}</div>
              {!attendances.length ? (
                <div>No attendance recorded</div>
              ) : (
                <div>
                  Attendance recorded from {attendances.length} session
                  {attendances.length === 1 ? '' : 's'}
                </div>
              )}
            </div>
          </div>
          <table className='table'>
            <thead>
              <tr>
                <th className='table__cell table__cell--left'>Class Title</th>
                <th className='table__cell table__cell--center table__cell-value--no-wrap'>Held On</th>
                <th className='table__cell table__cell--center table__cell-value--no-wrap'>
                  Students Present
                </th>
                <th className='table__cell table__cell--center'>Attendance</th>
              </tr>
            </thead>
            <tbody>
              {attendances.map((session) => (
                <tr key={session.classId}>
                  <td className='table__cell table__cell--left'>
                    {session.classNum < 0 ? 'Acadly not used' : `${session.classNum} - ${session.title}`}
                  </td>
                  <td className='table__cell table__cell--center table__cell-value--no-wrap'>
                    {dt.format(session.startTime, DATE_FORMAT)}
                  </td>
                  <td className='table__cell table__cell--center'>{session.numPresent}</td>
                  <td className='table__cell table__cell--center'>
                    {session.attendanceRecorded ? (
                      <span className={getAttendanceStyle(session.averageAttendance)}>
                        {session.averageAttendance}%
                      </span>
                    ) : (
                      '--'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Dialog>
  );
};

/**
 * Returns a color class name for a number between 0 and 100, returns empty string otherwise
 * @param percentage attendance percentage
 */
export const getAttendanceStyle = (percentage: number) => {
  if (percentage >= 80) return 'table__cell-value--green';
  else if (percentage >= 60) return 'table__cell-value--orange';
  return 'table__cell-value--red';
};

export default CourseAttendanceDetails;
